module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external "angular-cookies"
// module id = 14
// module chunks = 0